import Axios from 'axios'
import {activityCurrencyUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_activity_currencies (context) {
    Axios.get(activityCurrencyUrls.getAllActivityCurrencies).then(function (response) {
      context.commit('GET_ALL_ACTIVITY_CURRENCIES', response.data)
    })
  },
  get_activity_currencies (context, publicId) {
    Axios.get(activityCurrencyUrls.getActivityCurrencies + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_CURRENCIES', response.data)
    })
  },
  get_deleted_activity_currencies (context) {
    Axios.get(activityCurrencyUrls.getDeletedActivityCurrency).then(function (response) {
      context.commit('GET_DELETED_ACTIVITY_CURRENCIES', response.data)
    })
  },
  get_activity_currency (context, publicId) {
    Axios.get(activityCurrencyUrls.getActivityCurrency + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_CURRENCY', response.data)
    })
  },
  post_activity_currency (context, data) {
    Axios.post(activityCurrencyUrls.postActivityCurrency, data).then(function () {
      context.dispatch('get_all_activity_currencies')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_activity_currency (context, data) {
    Axios.post(activityCurrencyUrls.editActivityCurrency + data.public_id, data).then(function () {
      context.dispatch('get_all_activity_currencies')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_activity_currency (context, data) {
    Axios.post(activityCurrencyUrls.deleteActivityCurrency + data.public_id, data).then(function (response) {
      context.dispatch('get_all_activity_currencies')
    })
  },
  restoreActivityCurrency (context, publicId) {
    Axios.get(activityCurrencyUrls.restoreActivityCurrency + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_ACTIVITY_CURRENCIES', response.data)
      router.push({
        name: 'Module.ActivityCurrencies'
      })
    })
  }
}
